/**
 * Apollo Cache Storage for Web
 *
 * Provides persistence storage for Apollo Client cache
 * Uses localStorage for web (matching mobile's MMKV approach)
 */

import { storage } from './web-storage';

const APOLLO_CACHE_KEY = 'apollo_cache';

export interface ApolloCacheStorage {
    getItem: (key: string) => string | null;
    setItem: (key: string, data: string) => void;
    removeItem: (key: string) => void;
}

/**
 * Get Apollo cache storage adapter
 * Compatible with apollo3-cache-persist
 */
export const getApolloCacheStorage = (): ApolloCacheStorage => {
    return {
        getItem: (key: string): string | null => {
            return storage.getString(`${APOLLO_CACHE_KEY}_${key}`);
        },
        setItem: (key: string, data: string): void => {
            storage.setString(`${APOLLO_CACHE_KEY}_${key}`, data);
        },
        removeItem: (key: string): void => {
            storage.delete(`${APOLLO_CACHE_KEY}_${key}`);
        },
    };
};

export default getApolloCacheStorage;
